import { FormLabel as MuiFormLabel, type FormLabelProps as MuiFormLabelProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiFormLabelProps>;

export function FormLabel(props: Props) {
  return <MuiFormLabel {...props} />;
}

export type { Props as FormLabelProps };
